'use client'
import { motion } from 'motion/react';
import { useRouter } from 'next/navigation';
import React from 'react'
import { twMerge } from 'tailwind-merge';

interface Props
{
    children?: string;
    link: string;
    className?: string;
    hoverColor?: string;
}

const FooterLink = ({children, link, hoverColor='var(--foreground)', className=""}: Props) => {

    const router = useRouter()

    className = twMerge("footerlink ", className);
    
    const clickLink = (e: React.MouseEvent) => {
        router.push(link);
    }    

    return (
        <motion.button
            className={className}
            whileHover={{scale: 1.05, color: hoverColor}}
            whileTap={{scale: 1, color: hoverColor}}
            onClick={clickLink}
            >
            {children}
        </motion.button>
  )
}

export default FooterLink
